<div class="w-full max-w-7xl mx-auto p-4">
  
  <div class="flex border-b border-gray-300 dark:border-gray-700 mb-6">
    <button 
      (click)="activeTab = 'padron'" 
      [ngClass]="{'border-blue-600 text-blue-600 dark:text-blue-400': activeTab === 'padron', 'border-transparent text-gray-500 hover:text-gray-700 dark:text-gray-400': activeTab !== 'padron'}"
      class="py-2 px-6 font-bold text-base mx-2 border-b-2 focus:outline-none transition-colors duration-200 uppercase">
      Padrón de Residentes
    </button>
    <button 
      (click)="activeTab = 'pendientes'" 
      [ngClass]="{'border-blue-600 text-blue-600 dark:text-blue-400': activeTab === 'pendientes', 'border-transparent text-gray-500 hover:text-gray-700 dark:text-gray-400': activeTab !== 'pendientes'}"
      class="py-2 px-6 font-bold text-base mx-2 border-b-2 focus:outline-none transition-colors duration-200 uppercase">
      Pendientes por Registrar
    </button>
  </div>

    <div *ngIf="activeTab === 'padron'" class="space-y-6">
        <div class="text-gray-500 dark:text-gray-50 font-bold text-base text-center uppercase">
        PADRÓN DE RESIDENTES
        </div>

        <!--
            <button (click)="mostarModalEditNuevo(true)" 
                class="w-full inline-flex gap-2 justify-center items-center rounded-md border border-gray-200 shadow-md px-4 py-2 bg-teal-800 font-medium text-white hover:bg-emerald-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-emerald-300 transition-colors duration-150 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm">
                <svg class="w-5 h-5 text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/>
                </svg>
                NUEVO
            </button>
        -->
        
        <div class="w-full p-4 bg-white dark:bg-gray-800 rounded-lg shadow-md">

            <div class="mb-4 flex justify-end">
                <input 
                type="text" 
                placeholder="Filtrar por nombre o tarjeta..." 
                (keyup)="filtrar($event)"
                class="px-3 py-2 text-sm border rounded-md dark:bg-gray-700 dark:border-gray-600 dark:text-white outline-none w-full sm:w-64">
            </div>

            <ngx-datatable
                class="material striped"
                [rows]="rows"
                [columnMode]="'force'"
                [headerHeight]="50"
                [footerHeight]="50"
                [rowHeight]="'auto'"
                [limit]="pageSize">

                <ngx-datatable-column name="Nombre" prop="nombreCompleto" [width]="270" [minWidth]="220">
                <ng-template let-row="row" ngx-datatable-cell-template>
                    <span class="font-medium text-black-800 dark:text-white-500">
                    {{ row.nombreCompleto }}
                    </span>
                </ng-template>
                </ngx-datatable-column>

                
                <ngx-datatable-column 
                    name="No. Tarjeta" 
                    prop="noTarjeta"
                    [width]="100"
                    [minWidth]="90">
                <ng-template let-value="value" ngx-datatable-cell-template>
                    <span class="font-mono text-blue-600 dark:text-blue-400 font-semibold">
                    {{ value }}
                    </span>
                </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Fecha Registro" prop="fechaRegistro">
                <ng-template let-value="value" ngx-datatable-cell-template>
                    <span class="text-black-600 dark:text-black-300">
                    {{ value | date:'dd/MM/yyyy' }}
                    </span>
                </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Estado" prop="estatus" [width]="100" [minWidth]="90">
                <ng-template let-value="value" ngx-datatable-cell-template>
                    <span 
                    [ngClass]="value === 1 ? 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300' : 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-300'"
                    class="px-2.5 py-0.5 rounded-full text-xs font-semibold">
                    {{ value === 1 ? 'Activo' : 'Inactivo' }}
                    </span>
                </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Acciones" [sortable]="false" [width]="230" [minWidth]="220">
                    <ng-template let-row="row" ngx-datatable-cell-template>
                        <div class="flex flex-row items-center gap-2 flex-nowrap">
                            <!--
                                <button 
                                    (click)="editarResidente(row)"
                                    class="inline-flex items-center justify-center gap-1 w-24 py-1.5 bg-blue-600 hover:bg-blue-700 text-white text-xs font-medium rounded shadow-sm transition-colors whitespace-nowrap">
                                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"/>
                                    </svg>
                                    Editar
                                </button>
                            -->
                            <button 
                                (click)="toggleEstado(row)"
                                [ngClass]="row.estatus === 1 ? 'bg-gray-600 hover:bg-gray-600' : 'bg-teal-800 hover:bg-teal-800'"
                                class="inline-flex items-center justify-center gap-1 w-24 py-1.5 text-white text-xs font-medium rounded shadow-sm transition-colors whitespace-nowrap">
                                <ng-container *ngIf="row.estatus === 1; else btnActivarIcon">
                                <!-- Icono para Desactivar (Ban/Bloqueo) -->
                                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636"/>
                                </svg>
                                </ng-container>
                                <ng-template #btnActivarIcon>
                                <!-- Icono para Activar (Check Circle) -->
                                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
                                </svg>
                                </ng-template>

                            {{ row.estatus === 1 ? 'Desactivar' : 'Activar' }}
                            </button>

                        </div>

                    </ng-template>
                </ngx-datatable-column>

            </ngx-datatable>
        </div>
    </div>

    <div *ngIf="activeTab === 'pendientes'" class="space-y-6">
        <div class="text-gray-500 dark:text-gray-50 font-bold text-base text-center uppercase">
        ELEMENTOS PENDIENTES POR REGISTRAR
        </div>

        <div class="w-full p-4 bg-white dark:bg-gray-800 rounded-lg shadow-md">

            <div class="mb-4 flex justify-end">
                <input 
                type="text" 
                placeholder="Filtrar por codigo" 
                (keyup)="filtrarPreRegistro($event)"
                class="px-3 py-2 text-sm border rounded-md dark:bg-gray-700 dark:border-gray-600 dark:text-white outline-none w-full sm:w-64">
            </div>

            <ngx-datatable
                class="material striped"
                [rows]="filas"
                [columnMode]="'force'"
                [headerHeight]="50"
                [footerHeight]="50"
                [rowHeight]="'auto'"
                [limit]="pageSize">

                <ngx-datatable-column name="Secuencial" prop="rand_registro">
                <ng-template let-row="row" ngx-datatable-cell-template>
                    <span class="font-medium text-black-800 dark:text-white-500">
                    {{ row.rand_registro }}
                    </span>
                </ng-template>
                </ngx-datatable-column>

                
                <ngx-datatable-column 
                    name="No. Tarjeta" 
                    prop="no_tarjeta">
                <ng-template let-value="value" ngx-datatable-cell-template>
                    <span class="font-mono text-blue-600 dark:text-blue-400 font-semibold">
                    {{ value }}
                    </span>
                </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Fecha Registro" prop="fecha">
                <ng-template let-value="value" ngx-datatable-cell-template>
                    <span class="text-black-600 dark:text-black-300">
                    {{ value | date:'dd/MM/yyyy' }}
                    </span>
                </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Acciones" [sortable]="false">
                <ng-template let-row="row" ngx-datatable-cell-template>
                    <button 
                    (click)="asignarNuevo(row)"
                    class="inline-flex items-center justify-center gap-1 w-24 py-1.5 mx-2 bg-teal-800 hover:bg-cyan-600 text-white text-xs font-medium rounded shadow-sm transition-colors">
                    <svg class="w-4 h-4 text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/>
                    </svg>
                    Nuevo
                    </button>
                    <button 
                    (click)="asignarExistente(row)"
                    class="inline-flex items-center justify-center gap-1 w-24 py-1.5 mx-2 bg-blue-600 hover:bg-blue-700 text-white text-xs font-medium rounded shadow-sm transition-colors">
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"/>
                    </svg>
                    Asignar
                    </button>
                </ng-template>
                </ngx-datatable-column>

            </ngx-datatable>
        </div>
    </div>
</div>

<!-- Modales del form-->
<!-- Modal para hacer un nuevo residente o editar uno -->
<div *ngIf="formNuevoEditarResidente" class="modal-component-container w-full fixed inset-0 overflow-y-auto">
    <div class="modal-flex-container flex items-center justify-center max-h-screen pt-* px-4 pb-* text-center sm:block sm:p-0">
        <div class="modal-bg-container fixed inset-0 bg-gray-700 bg-opacity-75"></div>
        <div class="modal-space-container hidden sm:inline-block sm:align-middle sm:max-h-screen">&nbsp;</div>
        <div class="modal-container h-1/4 inline-block align-bottom bg-white dark:bg-gray-800 rounded-lg text-left shadow-xl transform transition-all sm:my-8 sm:align-middle sm:w-full max-w-4xl">
            <div>
                <div class="text-gray-500 dark:text-gray-50 font-bold text-base text-center uppercase">REGISTRO DE RESIDENTE</div>
                <form [formGroup]="residenteForm">
                <div class="grid grid-cols-4 gap-4">
                    <div>
                        <div class="text-gray-500 dark:text-gray-50 font-bold text-base text-center uppercase">id</div>
                        <input formControlName="id_padron" type="number" class="estilo-dark rounded text-black dark:text-gray-100 dark:bg-gray-700 bg-clip-padding border border-solid w-full" placeholder="No Padron">
                    </div>
                    <div>
                        <div class="text-gray-500 dark:text-gray-50 font-bold text-base text-center uppercase">Nombre</div>
                        <input formControlName="nombre" type="text" class="estilo-dark rounded text-black dark:text-gray-100 dark:bg-gray-700 bg-clip-padding border border-solid w-full" placeholder="Ej. Juan">
                    </div>
                    <div>
                        <div class="text-gray-500 dark:text-gray-50 font-bold text-base text-center uppercase">Apellido Paterno</div>
                        <input formControlName="apellido_paterno" type="text" class="estilo-dark rounded text-black dark:text-gray-100 dark:bg-gray-700 bg-clip-padding border border-solid w-full" placeholder="Ej. Jimenez">
                    </div>
                    <div>
                        <div class="text-gray-500 dark:text-gray-50 font-bold text-base text-center uppercase">Apellido Materno</div>
                        <input formControlName="apellido_materno" type="text" class="estilo-dark rounded text-black dark:text-gray-100 dark:bg-gray-700 bg-clip-padding border border-solid w-full" placeholder="Ej. Juarez">
                    </div>
                    <div>
                        <div class="text-gray-500 dark:text-gray-50 font-bold text-base text-center uppercase">Numero Tarjeta</div>
                        <input formControlName="no_tarjeton" type="text" class="estilo-dark rounded text-black dark:text-gray-100 dark:bg-gray-700 bg-clip-padding border border-solid w-full" placeholder="Ej. 234532456">
                    </div>
                    <div>
                        <div class="text-gray-500 dark:text-gray-50 font-bold text-base text-center uppercase">Fecha Registro</div>
                        <input formControlName="fecha_registro" type="date" class="estilo-dark rounded text-black dark:text-gray-100 dark:bg-gray-700 bg-clip-padding border border-solid w-full" placeholder="1900-01-01">
                    </div>
                </div>
                </form>
                <div class="modal-actions bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse dark:bg-gray-800">
                    <button (click)="GuardarCambios()" 
                    class="w-full inline-flex justify-center bg-teal-800 rounded-md border border-gray-300 shadow-md px-4 py-2  mt-3  font-medium text-white  hover:text-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-200 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm">
                        Guardar
                    </button>
                    <button (click)="mostarModalEditNuevo(false)"
                    class="w-full inline-flex justify-center bg-red-600 rounded-md border border-gray-300 shadow-md px-4 py-2  mt-3  font-medium text-white  hover:text-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-200 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm">
                        Cancelar
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>

<div 
  *ngIf="mostrarModalAsignar" 
  class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-gray-700 bg-opacity-75 transition-opacity">
  
  <div class="relative w-full max-w-md bg-white dark:bg-gray-800 rounded-lg shadow-xl overflow-visible">

    <div class="flex items-center justify-between p-4 border-b border-gray-200 dark:border-gray-700">
      <h3 class="text-lg font-semibold text-gray-900 dark:text-white">
        Asignar Persona Existente
      </h3>
      <button 
        (click)="cerrar()"
        type="button" 
        class="text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 rounded-lg p-1.5 inline-flex items-center">
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
        </svg>
      </button>
    </div>

    
    <div class="p-6">
      <label class="block text-xs font-bold uppercase text-gray-600 dark:text-gray-300 mb-2">
        Buscar Persona *
      </label>

      
      <div class="relative">
        <div class="relative flex items-center">
          
          <input 
            type="text"
            [(ngModel)]="busquedaCombo"
            (input)="filtrarOpciones()"
            (focus)="toggleDesplegable()"
            (blur)="alPerderFoco()"
            placeholder="Escriba para buscar..."
            class="w-full py-2 pl-3 pr-10 text-sm rounded border border-gray-300 dark:border-gray-600 dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500 uppercase">
          
          
          <button 
            type="button" 
            (click)="toggleDesplegable()"
            class="absolute right-0 top-0 bottom-0 px-3 text-gray-500 dark:text-gray-400 hover:text-gray-700 focus:outline-none">
            <svg class="w-4 h-4 transition-transform duration-200" [class.rotate-180]="desplegado" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
            </svg>
          </button>
        </div>

        
        <ul 
          *ngIf="desplegado" 
          class="absolute z-50 w-full mt-1 max-h-48 overflow-y-auto bg-white dark:bg-gray-700 border border-gray-200 dark:border-gray-600 rounded-md shadow-lg py-1 text-sm">
          
          <li 
            *ngFor="let persona of personasFiltradas"
            (mousedown)="seleccionarOpcion(persona)"
            class="px-4 py-2 hover:bg-blue-600 hover:text-white dark:hover:bg-blue-600 cursor-pointer transition-colors text-gray-800 dark:text-gray-100 flex items-center justify-between">
            <span>{{ persona.nombre + ' ' + persona.apellido_paterno + ' ' + persona.apellido_materno}}</span>
            <svg *ngIf="personaSeleccionada?.id === persona.id" class="w-4 h-4 text-blue-500 group-hover:text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
            </svg>
          </li>

          
          <li *ngIf="personasFiltradas.length === 0" class="px-4 py-3 text-gray-500 dark:text-gray-400 text-center text-xs">
            No se encontraron coincidencias
          </li>
        </ul>
      </div>
    </div>

   
    <div class="flex items-center justify-end gap-2 p-4 border-t border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800 rounded-b-lg">
      <button 
        (click)="cerrarModalAsignar()"
        type="button" 
        class="px-4 py-2 text-xs font-medium text-gray-700 dark:text-gray-300 bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm hover:bg-gray-50 dark:hover:bg-gray-600 transition-colors">
        Cancelar
      </button>

      <button 
        (click)="asignarPersona()"
        [disabled]="!personaSeleccionada"
        [class.opacity-50]="!personaSeleccionada"
        [class.cursor-not-allowed]="!personaSeleccionada"
        type="button" 
        class="px-4 py-2 text-xs font-medium text-white bg-blue-600 hover:bg-blue-700 rounded-md shadow-sm transition-colors flex items-center gap-1">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
        </svg>
        Confirmar Asignación
      </button>
    </div>

  </div>
</div>